<template>
  <div class="tabs-container">
    <DxTabs :data-source="tabs" :selected-index.sync="selectedIndex" @option-changed="onTabChanged"
      :item-template="tabTemplate" />

    <div v-if="selectedIndex === 0">
      <GridUtilizatorisiDrepturi />
      <!-- Add your content for the "Roluri" tab here -->
    </div>
    <div v-if="selectedIndex === 1">
      <GridRolurisiDrepturi />
      <!-- Add your content for the "Roluri" tab here -->
    </div>
    <div v-if="selectedIndex === 2">
      <GridDrepturiCustomsiMeniu />
    </div>
  </div>
</template>
<script>
import { DxTabs } from 'devextreme-vue/tabs';
import GridUtilizatorisiDrepturi from './GridUtilizatorisiDrepturi.vue';
import GridRolurisiDrepturi from './GridRolurisiDrepturi.vue';
import GridDrepturiCustomsiMeniu from './GridDrepturiCustomsiMeniu.vue';

export default {
  components: {
    GridDrepturiCustomsiMeniu,
    DxTabs,
    GridUtilizatorisiDrepturi,
    GridRolurisiDrepturi
  },
  data() {
    return {
      tabs: [

        { text: 'Drepturi Utilizatori' },
        { text: 'Drepturi Roluri' },
        { text: 'Drepturi Custom' },
      ],
      selectedIndex: 0,
    };
  },
  methods: {
    onTabChanged(e) {
      this.selectedIndex = e.component.option('selectedIndex');
    },
    tabTemplate(itemData, itemIndex, itemElement) {
      return `<div">${itemData.text}</div>`;
    },
  },
};
</script>
<style scoped></style>
